// Copyright (c) 2021 WiseTime. All rights reserved.

export const PAGE_CLASSNAME = "tl-page"
export const HEADER_CLASSNAME = "tl-header"
export const GROUPS_CONTENT_CLASSNAME = "tl-groups-content"
export const TOOLBAR_CLASSNAME = "tl-toolbar"
export const GROUP_TOOLBAR_CLASSNAME = "tl-group-toolbar"
export const GROUP_TABLE_HEADER_CLASSNAME = "tl-group-table-header"
export const REVIEW_PANEL_CLASSNAME = "tl-review-panel"
export const SCROLL_CONTAINER_CLASSNAME = "tl-scroll-container"
export const DROPDOWN_PARENT_CLASSNAME = "tl-dropdown-parent"
export const DROPDOWN_PARENT_ACTIVE_CLASSNAME = "tl-dropdown-parent--is-active"
export const DROPDOWN_CONTENT_CLASSNAME = "tl-dropdown-content"
export const TIME_ROW_CLASSNAME = "tl-time-row"
export const TIME_ROW_STATE_FAILED = "tl-time-row-state--is-failed"
export const TIME_ROW_STATE_NOT_POSTED = "tl-time-row-state--not-posted"
export const TIME_ROW_STATE_HIDE_ON_HOVER = "tl-time-row-state--hide-on-hover"
export const ROW_ACTIONS_CLASSNAME = "tl-time-block-row-actions"
export const ROW_COPY_TO_CLIPBOARD_CLASSNAME = "tl-time-block-row-copy-to-clipboard"
export const ROW_APP_ICON_CLASSNAME = "tl-time-block-row-app-icon"
export const ROW_DURATION_VISIBILITY_CLASSNAME = "tl-time-row-duration--toggle-visibility"
export const SUGGESTED_TAG_OVERLAY_CLASSNAME = "tl-suggested-tag-overlay"
export const DIALOG_WRAPPER_CLASSNAME = "tl-dialog-wrapper"
export const POST_TIME_BUTTON_CLASSNAME = "tl-post-time-button"
export const HEADING_ANCHOR_CLASSNAME = "tl-heading-anchor"
export const IS_DYNAMIC_SHADOW_CLASSNAME = "tl-is-dynamic-shadow"
export const TILES_CONTROL_CLASSNAME = "tl-tiles-control"
export const RESTRICTED_OVERLAY_CLASSNAME = "tl-restricted-overlay"
export const TIMESHEET_FIELD_DROPDOWN_HEADER_CLASSNAME = "tl-timesheet-field-dropdown-header"
export const TIMESHEET_FIELD_DIALOG_CLASSNAME = "tl-timesheet-field-dialog"
export const SIDEBAR_COLLAPSED_CLASSNAME = "wt-sidebar--collapsed"
